<div class="gsc-card" *ngIf="payload">
    <div class="gsc-header">
        <i class="ph-bold {{ headerIcon }}" aria-hidden="true"></i>
        <span class="gsc-header-title">{{ payload.title }}</span>
        <span class="gsc-spacer"></span>
        <span class="gsc-badge" *ngIf="payload.badge">{{ payload.badge }}</span>
    </div>

    <div class="gsc-item" *ngFor="let item of payload.items; trackBy: trackByIndex">
        <div class="gsc-item-main">
            <div class="gsc-item-title-row">
                <a class="gsc-item-title gsc-item-link"
                   *ngIf="item.href; else plainTitle"
                   [href]="item.href">{{ item.title }}</a>
                <ng-template #plainTitle>
                    <span class="gsc-item-title">{{ item.title }}</span>
                </ng-template>
                <span class="gsc-item-tag" *ngIf="item.tag">{{ item.tag }}</span>
            </div>
            <div class="gsc-item-meta" *ngIf="item.meta">{{ item.meta }}</div>
            <div class="gsc-item-reason" *ngIf="item.reason">
                <i class="ph-bold ph-sparkle" aria-hidden="true"></i>
                <span>{{ item.reason }}</span>
            </div>
        </div>
        <div class="gsc-item-side" *ngIf="item.recommendation || item.confidencePct != null || item.value">
            <span class="gsc-item-value" *ngIf="item.value">{{ item.value }}</span>
            <button type="button" class="gsc-item-pill" [ngClass]="toneClass(item)" *ngIf="item.recommendation" (click)="onItemAction(item)">
                {{ item.recommendation }}
            </button>
            <div class="gsc-item-confidence" *ngIf="item.confidencePct != null">
                {{ item.confidencePct }}% confident
            </div>
        </div>
    </div>

    <div class="gsc-footnote" *ngIf="payload.footnote">{{ payload.footnote }}</div>
</div>
